<template>
  <div class="jobs">
    <div class="row pb-5">
      <div class="col-12 col-lg-10 mx-auto">
        <div style="height:30px;">
          <div
            class="position-fixed bg-blue-br"
            style="width:100%;left:0;top:55px;z-index:4;max-height:30px"
          >
            <div class="row">
              <div class="col-12 col-lg-10 mx-auto">
                <SearchJob class="mx-3 shadow-sm searchJob"/>
              </div>
            </div>
          </div>
        </div>

        <Jobs/>
      </div>
    </div>
  </div>
</template>

<script>
import Jobs from "@/components/jobs/Jobs.vue";
import SearchJob from "@/components/jobs/SearchJob.vue";

export default {
  name: "JobsList",

  head(){
    return this.$head({
      title: "Vagas | ",
    });
  },

  components: {
    Jobs,
    SearchJob
  }
};
</script>

<style lang="scss">
.jobs {
  padding-top: 90px;

  .searchJob {
    .input-group {
      .form-control,
      .btn {
        height: calc(3.5rem + 2px);
        display: flex;
      }
    }
  }
}
</style>